export const Config = {
  "api_host": "/api/v1/",
  "public_client": "acme",
  "roi_cpa_campaign_margin": 0,
  "fullDateTimeFormat": "dd-MM-yyyy HH:mm",
  "dateTimeFormat": "dd-MM-yyyy",
  "timeFormat": "HH:mm",
  "defaultCurrency": "USD",
  "currencySymbol": "$",
  "search_debounce_delay": 750,
  "defaultLocale": "en-US",
  "defaultTimezone": "Asia/Kolkata",
  "basename": "/",
  "strategy_supply_type": "AAN",
  "support_link": "mailto:someone@yoursite.com?subject=Mail",
  "auth0": {
    "domain": "mediamath.auth0.com",
    "clientId": "LFwm2S1nAkGNPzAhoeK961UnR2gXv89O"
  },
  "defaultReportColumns": {
    "app-transparency": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "site-transparency": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_revenue",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "geo": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "performance": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_revenue",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "new-to-brand": [
      "agency_name",
      "campaign_id",
      "campaign_name",
      "total_conversions",
      "total_conversions_revenue",
      "total_unique_converters",
      "total_spend",
      "total_ntb_conversions",
      "total_ntb_revenue",
      "total_ntb_converters",
      "incremental_roas",
      ],
  },
  "hideReportColumns": {
    "app-transparency": ["ctc", "ctr", "impressions"],
    "site-transparency": [],
    "geo": [],
    "performance": [],
    "new-to-brand": [],
  },
  "reportingRowsPerPage": 10
};
